// input divideArray([1, 2, 3, 4, 5, 6], 2, 6)
// output [[1, 2], [3, 4], [5, 6]]
export const divideArray = (
  array: any[],
  itemLength: number,
  itemsCount: number
) => {
  const ans = [];
  let temp = [];

  for (let i = 0; i < itemsCount; i++) {
    temp.push(array[i]);

    if ((i + 1) % itemLength == 0) {
      ans.push(temp);
      temp = [];
    }
  }

  // If last group doesn't have enough
  // elements then add null to it
  if (temp.length != 0) {
    let a = temp.length;

    while (a != itemLength) {
      temp.push(null);
      a++;
    }

    ans.push(temp);
  }

  return ans;
};
